import Loadable from "app/components/Loadable";
import { lazy } from "react";

const WorkScheduleList = Loadable(lazy(() => import("./WorkScheduleList")));
const WorkScheduleForm = Loadable(lazy(() => import("./WorkScheduleForm")));

const workScheduleRoutes = [
  {
    path: "/WorkSchedule/WorkScheduleList",
    element: <WorkScheduleList />,
  },
  {
    path: "/WorkSchedule/WorkScheduleForm",
    element: <WorkScheduleForm />,
  },
  {
    path: "/WorkSchedule/WorkScheduleForm/:id",
    element: <WorkScheduleForm />,
  },
];
export default workScheduleRoutes;
